class TurboNativeBridge {
  static toggleNavBar() {
    window.navbar.classList.toggle("hidden");
  }
}

export default TurboNativeBridge;
